export default __webpack_public_path__ + "24f10ad9842b2c8fb527ad807d849f46.png";